var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5L11.9427 8.44267C11.6926 8.19271 11.3536 8.05229 11 8.05229C10.6464 8.05229 10.3074 8.19271 10.0573 8.44267L4 14.5M3.33333 2.5H12.6667C13.403 2.5 14 3.09695 14 3.83333V13.1667C14 13.903 13.403 14.5 12.6667 14.5H3.33333C2.59695 14.5 2 13.903 2 13.1667V3.83333C2 3.09695 2.59695 2.5 3.33333 2.5ZM7.33333 6.5C7.33333 7.23638 6.73638 7.83333 6 7.83333C5.26362 7.83333 4.66667 7.23638 4.66667 6.5C4.66667 5.76362 5.26362 5.16667 6 5.16667C6.73638 5.16667 7.33333 5.76362 7.33333 6.5Z",
    stroke: "#828FAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.821e1b687f93a60874a5b095958760f7.svg";
export { ForwardRef as ReactComponent };